import React, { useState } from "react";
import {
  AUDITS,
  periodLabel,
  DRINKS,
  usd,
  editForm,
  payload,
  useResource,
} from "./coffeeUi";
import { errorMessage } from "./coffeeApi";
import CoffeeFields from "./CoffeeFields";
import CoffeePhotos from "./CoffeePhotos";
export default function CoffeeDetail({
  id,
  internal,
  request,
  onClose,
  onSaved,
}) {
  const [refresh, setRefresh] = useState(0);
  const resource = useResource(
    `${internal ? "/internal" : "/mine"}/${id}`,
    request,
    refresh
  );
  const [form, setForm] = useState(null),
    [reason, setReason] = useState(""),
    [error, setError] = useState(""),
    [busy, setBusy] = useState(false);
  const item = resource.data;
  const save = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await request(
        `/internal/${id}`,
        { ...payload(form), reason, expectedVersion: item.machineVersion },
        "PATCH"
      );
      setForm(null);
      setRefresh((x) => x + 1);
      onSaved();
    } catch (err) {
      setError(errorMessage(err));
      if (err?.response?.status === 409) {
        setForm(null);
        setRefresh((x) => x + 1);
      }
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="coffee-modal-backdrop">
      <div
        className="coffee-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Detalle del registro"
      >
        <div className="coffee-heading">
          <h2>Detalle del registro</h2>
          <button type="button" disabled={busy} onClick={onClose}>
            Cerrar
          </button>
        </div>
        {resource.loading && <p role="status">Cargando…</p>}
        {resource.error && (
          <p role="alert">
            {resource.error}{" "}
            <button onClick={() => setRefresh((x) => x + 1)}>Reintentar</button>
          </p>
        )}
        {error && <p role="alert">{error}</p>}
        {item && (
          <>
            <p>
              {item.snapshot?.name} · {item.snapshot?.serialNumber} ·{" "}
              {item.snapshot?.location}
            </p>
            <p>
              Ruta: {item.snapshot?.route} · Operador: {item.snapshot?.operator}
            </p>
            {form ? (
              <form onSubmit={save}>
                <fieldset disabled={busy}>
                  <CoffeeFields
                    form={form}
                    setForm={setForm}
                    previous={item.previousCounter}
                    first={item.initialCounter != null && item.sequence === 1}
                  />
                  <label>
                    Motivo de corrección *
                    <textarea
                      required
                      maxLength={500}
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                    />
                  </label>
                  <div className="coffee-actions">
                    <button className="coffee-primary" disabled={busy}>
                      Guardar corrección
                    </button>
                    <button type="button" onClick={() => setForm(null)}>
                      Cancelar
                    </button>
                  </div>
                </fieldset>
              </form>
            ) : (
              <>
                <dl className="coffee-detail-grid">
                  <div>
                    <dt>Período</dt>
                    <dd>{periodLabel(item)}</dd>
                  </div>
                  <div>
                    <dt>Contadores</dt>
                    <dd>
                      {item.previousCounter ?? "—"} → {item.currentCounter}
                    </dd>
                  </div>
                  <div>
                    <dt>Consumo</dt>
                    <dd>{item.consumption ?? "—"}</dd>
                  </div>
                  <div>
                    <dt>Total de ventas</dt>
                    <dd>{usd(item.totalSalesCents)}</dd>
                  </div>
                  {DRINKS.map((name, i) => (
                    <div key={name}>
                      <dt>{name}</dt>
                      <dd>{item.drinks?.[i] ?? "Sin reportar"}</dd>
                    </div>
                  ))}
                  <div>
                    <dt>Pruebas</dt>
                    <dd>{item.tests ?? "Sin reportar"}</dd>
                  </div>
                  {AUDITS.map((name, i) => (
                    <div key={name}>
                      <dt>{name}</dt>
                      <dd>{usd(item.auditsCents?.[i])}</dd>
                    </div>
                  ))}
                </dl>
                {(item.photos?.length || item.photo) && (
                  <section>
                    <h3>Imágenes del registro</h3>
                    <CoffeePhotos photos={item.photos?.length ? item.photos : [item.photo]} readOnly />
                  </section>
                )}
                {item.reason && <p>Motivo del reinicio: {item.reason}</p>}
                {internal && item.kind === "reading" && (
                  <button
                    type="button"
                    onClick={() => {
                      setForm(editForm(item));
                      setReason("");
                    }}
                  >
                    Corregir registro
                  </button>
                )}
              </>
            )}
            <h3>Historial de correcciones</h3>
            {!item.revisions?.length && <p>Sin correcciones.</p>}
            {item.revisions?.map((revision, i) => (
              <details key={i}>
                <summary>
                  {new Date(revision.at).toLocaleString("es-PA", {
                    timeZone: "America/Panama",
                  })}{" "}
                  · {revision.actorName} · {revision.reason}
                </summary>
                <p>Valores anteriores a la corrección:</p>
                <dl className="coffee-detail-grid">
                  <div>
                    <dt>Período</dt>
                    <dd>{periodLabel(revision.before)}</dd>
                  </div>
                  <div>
                    <dt>Contadores</dt>
                    <dd>
                      {revision.before.previousCounter ?? "—"} →{" "}
                      {revision.before.currentCounter}
                    </dd>
                  </div>
                  <div>
                    <dt>Consumo</dt>
                    <dd>{revision.before.consumption ?? "—"}</dd>
                  </div>
                  <div>
                    <dt>Total de ventas</dt>
                    <dd>{usd(revision.before.totalSalesCents)}</dd>
                  </div>
                  {DRINKS.map((name, index) => (
                    <div key={name}>
                      <dt>{name}</dt>
                      <dd>
                        {revision.before.drinks?.[index] ?? "Sin reportar"}
                      </dd>
                    </div>
                  ))}
                  <div>
                    <dt>Pruebas</dt>
                    <dd>{revision.before.tests ?? "Sin reportar"}</dd>
                  </div>
                  {AUDITS.map((name, index) => (
                    <div key={name}>
                      <dt>{name}</dt>
                      <dd>{usd(revision.before.auditsCents?.[index])}</dd>
                    </div>
                  ))}
                </dl>
              </details>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
